import { IconProp } from '@fortawesome/fontawesome-svg-core'

import { DialogWrapper } from '@/components'
import { ContextMenuItem } from '@/components/ContextMenu/ContextMenu'
import { StructureDto, StructureObjectDto } from '@/endpoints/models'

import { AddModal } from '../../../components/AddModal'

type Props = {
	color?: string
	disabled?: boolean
	icon: IconProp
	label: string
	node: StructureDto
	onRefresh?: () => void,
	type: StructureObjectDto.TypeEnum
}

const renderDialog = (
	opened: boolean,
	onClose: () => void,
	node: StructureDto,
	type?: StructureObjectDto.TypeEnum,
	onRefresh?: () => void,
) =>
	opened && (
		<AddModal
			node={node}
			type={type as StructureObjectDto.TypeEnum}
			onClose={onClose}
			onRefresh={onRefresh}
		/>
	)

export const AddNodeItem = ({ node, type, label, icon, onRefresh, disabled }: Props) => (
	<DialogWrapper
		dialog={(opened, onClose) => renderDialog(opened, onClose, node, type, onRefresh)}
	>
		{(onClick) => (
			<ContextMenuItem
				onClick={onClick}
				role="menuitem"
				icon={icon}
				color="gray"
				title={label}
				disabled={disabled}
			/>
		)}
	</DialogWrapper>
)
